var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ThemeMode, Locale, ButtonType, Edges, MerchantCapabilities } from '../constants';
export var getDefaultValues = function (mainObject) {
    var userThemeMode = window.matchMedia('(prefers-color-scheme: light)').matches ? ThemeMode.LIGHT : ThemeMode.DARK;
    var userLang = navigator.language.toLowerCase().includes(Locale.AR) ? Locale.AR : Locale.EN;
    var defaultInterface = {
        locale: userLang,
        theme: userThemeMode,
        type: ButtonType.PLAIN,
        edges: Edges.CURVED
    };
    return __assign(__assign({}, mainObject), { interface: __assign(__assign({}, defaultInterface), mainObject.interface) });
};
export var getMerchantCapaplities = function (supportedCards) {
    var merchantCapaplities = [MerchantCapabilities.Supports3DS];
    if (!supportedCards) {
        merchantCapaplities = __spreadArray(__spreadArray([], merchantCapaplities, true), [
            MerchantCapabilities.SupportsCredit,
            MerchantCapabilities.SupportsDebit
        ], false);
    }
    else if (supportedCards.includes('CREDIT')) {
        merchantCapaplities.push(MerchantCapabilities.SupportsCredit);
    }
    else if (supportedCards.includes('DEBIT')) {
        merchantCapaplities.push(MerchantCapabilities.SupportsDebit);
    }
    return merchantCapaplities;
};
